import { DragDropModule } from '@angular/cdk/drag-drop';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import {
  MatMultiSort,
  MatMultiSortHeaderComponent,
  MatMultiSortModule,
} from 'ngx-mat-multi-sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';

/** Standalone APIs must be re-exported; MatMultiSortModule does not export them to importers. */
const NGX_MAT_MULTI_SORT = [
  MatMultiSortModule,
  MatMultiSort,
  MatMultiSortHeaderComponent,
];

const MATERIAL_MODULES = [
  MatSidenavModule,
  MatListModule,
  MatTabsModule,
  MatTableModule,
  ...NGX_MAT_MULTI_SORT,
  MatCheckboxModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  MatIconModule,
  MatPaginatorModule,
  MatSelectModule,
  MatInputModule,
  DragDropModule,
  MatExpansionModule,
  MatDialogModule,
  MatTooltipModule,
  MatRadioModule,
  MatChipsModule,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, PlatformModule, ...MATERIAL_MODULES],
  exports: [...MATERIAL_MODULES, PlatformModule],
})
export class AngularMaterialModule {}
